module.exports = __webpack_public_path__ + "img/3.c5c781a3.png";